import { LoadingOutlined } from "@ant-design/icons";


const LoadingComponent = <LoadingOutlined style={{ fontSize: 24, }} spin />;


export default LoadingComponent;

